import userManagementHttps from "../../axios/userManagement";
import { UserSetupPayload } from "../../db/action/userSetup";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";
import { UserActivationRequest, UserActivationAPIResponse } from "../../api/types/userManagement.types";

export interface UserSetupResponse extends BaseResponse {
  data?: {
    message: string;
    userId: string;
    accountId?: string;
    role: string;
  };
}

export const doUserSetup = async (
  params: UserSetupPayload,
): Promise<UserSetupResponse> => {
  try {
    // Map UserSetupPayload to UserActivationRequest format
    const activationPayload: UserActivationRequest = {
      email: params.email,
      password: params.password,
      confirmPassword: params.confirmPassword,
      firstName: params.firstName,
      lastName: params.lastName,
      phoneType: params.phoneType,
      phoneNumber: params.phoneNumber,
    };

    const response = await userManagementHttps.post<UserActivationAPIResponse>(
      "activate",
      activationPayload
    );

    // Transform response to match expected format
    if (response.data.status === "SUCCESS" && response.data.data) {
      return {
        ...normalizeBaseResponse(response.data),
        data: {
          message: "User activated successfully",
          userId: String(response.data.data.userId),
          role: "", // Role not returned in activation response
        },
      };
    }

    return {
      ...normalizeBaseResponse(response.data),
      data: response.data?.data as any,
    };
  } catch (error) {
    return errorHandler(error);
  }
};

